// API Configuration
// This will be the single point of configuration for all API calls

import { CONFIG } from '../constants';

const API_BASE = CONFIG.API_BASE_URL ? `${CONFIG.API_BASE_URL}/api/v1` : '/api/v1';

/**
 * Base fetch wrapper with error handling
 */
async function fetchApi(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  // Add auth token if available
  const token = localStorage.getItem('authToken');
  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
}

// Export the fetch wrapper
export const api = {
  get: (endpoint) => fetchApi(endpoint, { method: 'GET' }),
  post: (endpoint, data) => fetchApi(endpoint, { method: 'POST', body: JSON.stringify(data) }),
  put: (endpoint, data) => fetchApi(endpoint, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (endpoint) => fetchApi(endpoint, { method: 'DELETE' }),
};

export default api;
